<template>
	<ui-card icon="fal fa-key" title="Permissões">
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<div class="internal-header">
					<h2 class="title">Permissão para Excluir Clientes</h2>
					<span class="desc">Defina a regra de exclusão de clientes cadastrados. </span>
				</div>

				<ui-util-box-text-slot
					title=" (Médio) Usuários podem excluir clientes cadastrados por eles"
					design="no-bb"
				>
					<ui-switch
						:checked="checked.permissionDelete"
						@input="updatePermissionDelete"
						design="xs"
					/>
				</ui-util-box-text-slot>

				<ui-util-box-text-slot
					title="(Forte) Somente administradores podem excluir clientes."
					design="mb"
				>
					<ui-switch
						:checked="!checked.permissionDelete"
						@input="updatePermissionDelete($event, true)"
						design="xs"
					/>
				</ui-util-box-text-slot>

				<div class="internal-header line-t">
					<h2 class="title">Permissão para Excluir Negócios</h2>
					<span class="desc">Defina a regra de exclusão de negócios cadastrados.</span>
				</div>

				<ui-util-box-text-slot
					title=" (Médio) Usuários podem excluir negócios cadastrados por eles."
					design="no-bb"
				>
					<ui-switch
						:checked="checked.permissionDeleteDeal"
						@input="updatePermissionDeleteDeal"
						design="xs"
					/>
				</ui-util-box-text-slot>

				<ui-util-box-text-slot
					title="(Forte) Somente administradores podem excluir negócios."
					design="mb"
				>
					<ui-switch
						:checked="!checked.permissionDeleteDeal"
						@input="updatePermissionDeleteDeal($event, true)"
						design="xs"
					/>
				</ui-util-box-text-slot>
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSwitch } from '@/components/ui/form'
	import { uiUtilBoxTextSlot } from '@/components/ui/form/util'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	const defaultForm = () => ({
		customerDuplicate: null,
	})

	const defaultDisabled = () => ({})

	const defaultChecked = () => ({
		ownerDuplicate: false,
		permissionDelete: false,
		permissionDeleteDeal: false,
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-customers-permissions',

		components: {
			uiCard,
			uiButton,
			uiSwitch,
			uiLoadSuccess,
			uiLoadIndicator,
			uiUtilBoxTextSlot,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				checked: { ...defaultChecked() },
				loader: { ...defaultLoader() },
				oldForm: {},
			}
		},

		async created() {
			this.loader.body = true

			this.form.customerDuplicate = await this.getConfig('customerDuplicate', 'value_long')

			this.checked.permissionDelete = this.$mx_checkIsOnlyOwner(
				this.form.customerDuplicate.permissionDelete,
			)

			this.checked.permissionDeleteDeal = this.$mx_checkIsOnlyOwner(
				this.form.customerDuplicate.permissionDeleteDeal,
			)

			this.loader.body = false
			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body
			},

			customerDuplicateData() {
				const data = this.$mx_copyObject(this.form.customerDuplicate)

				// Replace Array[0] to null
				return this.$mx_replaceDataValue(data, "[[\]]", "[null]")
			},
		},

		methods: {
			getConfig,
			saveConfig,

			updatePermissionDelete(value, toggle = false) {
				const bool = toggle ? !value : value
				this.checked.permissionDelete = bool
				this.form.customerDuplicate.permissionDelete = this.$mx_onlyOwnerOrDenied(bool)
			},

			updatePermissionDeleteDeal(value, toggle = false) {
				const bool = toggle ? !value : value
				this.checked.permissionDeleteDeal = bool
				this.form.customerDuplicate.permissionDeleteDeal = this.$mx_onlyOwnerOrDenied(bool)
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await this.saveConfig(
						'customerDuplicate',
						this.customerDuplicateData,
						'value_long',
					)

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
